import { Alert, Button, Col, Grid, Row, Table } from 'react-bootstrap'
import React, { Component } from 'react'
import {
  getAnomalousCorrelation,
  getAttachmentByAutoprocProgramId,
  getAutoprocResultsByDataCollectionId,
  getCC2,
  getCompleteness,
  getISigma,
  getRFactor,
  getSigmaAnomalous,
} from '../api/ispyb.js'

import AutoProcProgramAttachentList from '../components/Mx/AutoprocIntegration/AutoProcProgramAttachmentList.js'
import AutoProcProgramXScalePlot from '../components/Mx/AutoprocIntegration/AutoProcProgramXScalePlot.js'
import PropTypes from 'prop-types'
import ResultListDataCollectionGroupPanel from '../components/Mx/DataCollectionGroup/ResultListDataCollectionGroup/ResultListDataCollectionGroupPanel.js'
import Sidebar from 'react-sidebar'
import { axios } from 'config/axios'
import concat from 'lodash/concat'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import flatten from 'lodash/flatten'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'
import uniq from 'lodash/uniq'

const mql = window.matchMedia('(min-width: 800px)')

class MXAutoprocessingContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: true,
      workflows: [],
      autoprocintegrations: [],
      attachments: {
        data: [],
        fetching: false,
        fetched: false,
      },
      selected: [],
      sidebarOpen: true,
      sidebarDocked: mql.matches,
    }
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this)
    this.onButtonClicked = this.onButtonClicked.bind(this)
  }
  // FIXME bmo20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged)
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open })
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
  }

  onButtonClicked() {
    this.onSetSidebarOpen(!this.state.sidebarOpen)
  }
  /**
   * This method will retrieve the experiments for a given session
   * A experiment might be calibration, sample changer or HPLC
   */
  componentDidMount() {
    var _this = this

    axios({
      method: 'GET',
      url: getAutoprocResultsByDataCollectionId(this.props.user, this.props.proposal, this.props.dataCollectionId),
    })
      .then(function (response) {
        _this.setState({
          autoprocintegrations: response.data,
          fetching: false,
          fetched: true,
        })
      })
      .catch(function (error) {
        _this.setState({
          error: error,
          fetching: false,
          fetched: false,
        })
      })
  }

  getLastSelected(selected) {
    if (selected.length > 0) {
      return find(flatten(this.state.autoprocintegrations), {
        AutoProcIntegration_autoProcIntegrationId: selected[selected.length - 1],
      })
    }
    return []
  }

  getFiles(selected) {
    var selectedAutoProc = this.getLastSelected(selected)
    this.setState({
      attachments: {
        data: [],
        //fetching : true,
        fetched: false,
      },
    })

    axios({
      method: 'GET',
      url: getAttachmentByAutoprocProgramId(
        this.props.user,
        this.props.proposal,
        selectedAutoProc.v_datacollection_summary_phasing_autoProcProgramId
      ),
    })
      .then(response => {
        this.setState({
          attachments: {
            data: response.data,
            fetching: false,
            fetched: true,
          },
        })
      })
      .catch(() => {
        this.setState({
          attachments: {
            data: [],
            fetching: false,
            fetched: false,
          },
        })
      })
  }

  update(selected) {
    this.getFiles(selected)
  }

  select(autoprocIntegrationId) {
    var copy = concat(this.state.selected, [autoprocIntegrationId])
    this.setState(state => {
      const selected = uniq([...state.selected, autoprocIntegrationId])
      return {
        selected,
        value: autoprocIntegrationId,
      }
    })
    this.update(copy)
  }

  unselect = autoprocIntegrationId => {
    const selected = this.state.selected.filter(item => autoprocIntegrationId !== item)

    this.setState(state => ({
      selected: state.selected.filter(item => autoprocIntegrationId !== item),
    }))

    this.update(selected)
  }

  getSideBarMenu() {
    return (
      <Table>
        {this.state.autoprocintegrations.map(autoprocintegration =>
          autoprocintegration.map(value => {
            if (value.v_datacollection_processingStatus === 'FAILED') {
              return (
                <tr style={{ border: '1px solid red' }}>
                  <td>
                    <Alert bsStyle="danger">
                      <p>
                        <strong>{value.v_datacollection_processingPrograms}</strong>
                      </p>
                      <p>{value.v_datacollection_processingStatus}</p>
                      <p className="text-secondary" style={{ fontSize: '10px' }}>
                        id : {value.AutoProcIntegration_autoProcIntegrationId}
                      </p>
                    </Alert>
                  </td>
                </tr>
              )
            }
            return (
              // FIXME bmo20210210
              // eslint-disable-next-line react/jsx-key
              <tr style={{ border: '1px solid gray' }}>
                <td>
                  <Alert bsStyle="warning">
                    <p>
                      <strong>{value.v_datacollection_processingPrograms}</strong>
                    </p>
                    <p>{value.v_datacollection_summary_phasing_autoproc_space_group}</p>
                    {value.anomalous?.indexOf('0') === -1 && <p>ANOMALOUS</p>}
                    <p className="text-secondary" style={{ fontSize: '10px' }}>
                      id : {value.AutoProcIntegration_autoProcIntegrationId}
                    </p>
                    {this.state.selected.includes(value.AutoProcIntegration_autoProcIntegrationId) ? (
                      <Button
                        bsStyle="danger"
                        bsSize="xsmall"
                        onClick={() => this.unselect(value.AutoProcIntegration_autoProcIntegrationId)}
                      >
                        Deselect
                      </Button>
                    ) : (
                      <Button
                        bsStyle="primary"
                        bsSize="xsmall"
                        onClick={() => this.select(value.AutoProcIntegration_autoProcIntegrationId)}
                      >
                        Select
                      </Button>
                    )}
                  </Alert>
                </td>
              </tr>
            )
          })
        )}
      </Table>
    )
  }

  render() {
    var _this = this
    if (!this.props.user || !this.props.user.token) {
      return null
    }

    // This gets the autoprocintegrations that are selected
    var autoprocs = filter(flatten(this.state.autoprocintegrations), function (a) {
      return find(_this.state.selected, function (selectedAutoProcIntegrationId) {
        return a.AutoProcIntegration_autoProcIntegrationId === selectedAutoProcIntegrationId
      })
    })

    return (
      <Sidebar
        styles={{
          root: {
            zIndex: 1,
            position: 'fixed',
            top: 100,
          },
        }}
        sidebar={this.getSideBarMenu()}
        open={this.state.sidebarOpen}
        docked={this.state.sidebarDocked}
        onSetOpen={this.onSetSidebarOpen}
        shadow
      >
        <Grid fluid style={{ margin: 5 }}>
          <Row className="show-grid">
            <Col>
              <ResultListDataCollectionGroupPanel
                showIds
                results={autoprocs}
                user={this.props.user}
                proposal={this.props.proposal}
                configuration={this.props.configuration}
                jobs={this.props.jobs}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={9}>
              <Grid>
                <Row>
                  <Col xs={12} md={6}>
                    <AutoProcProgramXScalePlot
                      title="R Factor vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getRFactor}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={4}>
                    <AutoProcProgramXScalePlot
                      title="CC2 vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getCC2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <AutoProcProgramXScalePlot
                      title="SigAno vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getSigmaAnomalous}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={4}>
                    <AutoProcProgramXScalePlot
                      title="I/Sigma(I) vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getISigma}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <AutoProcProgramXScalePlot
                      title="Anom. corr. vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getAnomalousCorrelation}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={4}>
                    <AutoProcProgramXScalePlot
                      title="Completeness vs Resolution"
                      user={this.props.user}
                      proposal={this.props.proposal}
                      autoProcIntegrationIds={this.state.selected}
                      call={getCompleteness}
                    />
                  </Col>
                </Row>
              </Grid>
            </Col>
            <Row>
              <Col xs={12} lg={3}>
                <AutoProcProgramAttachentList
                  fetching={this.state.attachments.fetching}
                  fetched={this.state.attachments.fetched}
                  data={this.state.attachments.data}
                  user={this.props.user}
                  proposal={this.props.proposal}
                />
              </Col>
            </Row>
          </Row>
        </Grid>
      </Sidebar>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    jobs: state.jobs,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

MXAutoprocessingContainer.propTypes = {
  sessionId: PropTypes.string,
  dataCollectionId: PropTypes.string,
  proposal: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(MXAutoprocessingContainer)
